// --- React
import React from 'react';
import PropTypes from 'prop-types';
// --- Components
import { CopyButton } from './CopyButton';

/**
 * Formats a value for display, handling empty/null/undefined values
 */
const formatValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return '—';
    }
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }
    return String(value);
};

/**
 * DetailRow Component (tap-ui style)
 *
 * Displays a single field with label on left and value on right.
 * Matches tap-ui styling conventions.
 *
 * @param {string} label - The field label
 * @param {any} value - The field value
 * @param {boolean} copyable - Whether to show copy button
 * @param {boolean} noBorder - Whether to hide the bottom border
 */
export const FieldRow = ({ label, value, copyable = false, noBorder = false }) => {
    const displayValue = formatValue(value);
    const hasValue = value !== null && value !== undefined && value !== '';

    return (
        <div className={`detail-row${noBorder ? ' no-border' : ''}`}>
            <span className="detail-row-label">{label}</span>
            <span className="detail-row-value">
                {displayValue}
                {copyable && hasValue && <CopyButton value={value} />}
            </span>
        </div>
    );
};

FieldRow.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    copyable: PropTypes.bool,
    noBorder: PropTypes.bool,
};

// Export as both names for compatibility
export const DetailRow = FieldRow;
export default FieldRow;
